import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../environments/environment';

export const emptyStringToNullInterceptor: HttpInterceptorFn = (req, next) => {
  // Only intercept requests going to the API
  const targetUrls: string[] = [environment.apiUrl];

  const shouldIntercept = targetUrls.some((prefix) => req.url.startsWith(prefix));

  // Skip file uploads (FormData, Blob, File)
  if (
    !shouldIntercept ||
    req.body instanceof FormData ||
    req.body instanceof Blob ||
    req.body instanceof File
  ) {
    return next(req);
  }

  // Normalize empty strings to null recursively
  if (req.body && typeof req.body === 'object') {
    const normalize = (value: unknown): unknown => {
      if (value === '') {
        return null;
      } else if (Array.isArray(value)) {
        return value.map((v) => normalize(v));
      } else if (value !== null && typeof value === 'object') {
        return Object.fromEntries(
          Object.entries(value).map(([k, v]) => [k, normalize(v)])
        );
      }
      return value;
    };

    const normalizedBody = normalize(req.body);
    const cloned = req.clone({ body: normalizedBody });
    return next(cloned);
  }

  return next(req);
};
